import React, { useCallback, useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "../../common/translation-context";
import {
  APP_VIEW,
  EXTENSION_COLUMNS,
} from "../../constants/constant";
import { fetchErrors } from "../../store/slices/extension";
import { getUserRole } from "../../utils/utils";
import ToastMessageFunction from "../../common/toast-message-function";
import ErrorContext from "../../common/error-context";
import ExtDataGrid from "../../common/data-grid/ext-data-grid";

export default function ErrorPage() {
  const dispatch = useDispatch();
  const errCxt = useContext(ErrorContext);
  const { translate: t } = useTranslation();
  const userData = useSelector((state) => state.userState.userData);
  const toastManager = ToastMessageFunction();

  const {
    errors,
    loading: errorsLoading,
    error: errorsError,
  } = useSelector((state) => state.errorsExtension);

  const showToast = useCallback(
    (message, severity) => {
      toastManager.getToast(message, severity);
    },
    [toastManager],
  );

  useEffect(() => {
    dispatch(fetchErrors());
  }, [dispatch]);

  useEffect(() => {
    if (errors?.length !== undefined) {
      errCxt.setPopUpData(errors.length);
    }
  }, [errors, errCxt]);

  useEffect(() => {
    if (errorsError) {
      showToast(errorsError, "error");
    }
  }, [errorsError, showToast]);

  return (
    <div>
      <div className="extension-header">
        <h3>
          {t("errors")} ({errCxt.popUpData})
        </h3>
      </div>
      <ExtDataGrid
        view={APP_VIEW.ERRORS}
        panelView={getUserRole(userData) === "CCM" ? APP_VIEW.CCM : APP_VIEW.BP}
        columns={EXTENSION_COLUMNS}
        rows={errors}
        isLoaderVisible={errorsLoading}
        showToast={showToast}
      />
      {toastManager.toast}
    </div>
  );
}
